import { module } from 'angular';
import BookmarkModel from './bookmark.model';

export default module('app')
	.service('Bookmark', BookmarkModel);
